<template>
  <div class="AppFileUploadHint rounded-lg elevation-10">
    <div class="header-icon">
      <div class="header-icon__stack">
        <app-material-icon name="circle"
                           filled
                           :style="{color: isError ? '#DEE2E6' : '#2196F3'}"
                           :size="72"
        >
        </app-material-icon>
        <app-material-icon v-if="!isError"
                           name="folder"
                           color="white"
                           filled
                           :size="36"
                           style="color: white; top: 20px; left: 18px"
        />
        <app-material-icon v-if="!isError"
                           name="arrow_upward"
                           color="#2196F3"
                           filled
                           style="top: 29px; left: 26px"
        />
        <app-material-icon v-if="isError"
                           name="scan_delete"
                           color="white"
                           :size="36"
                           style="color: white; top: 20px; left: 18px"
        />
      </div>
    </div>

    <span class="text-body-2 my-1 text-center"
          v-html="$t(
            isError
              ? `common.app-file-upload.AppFileUploadHint.${uploadHint.messageType}`
              : 'common.app-file-upload.AppFileUploadHint.textMovable', { count: documentsToMove?.documents?.length }, documentsToMove?.documents?.length,
          )"
    />

    <div v-if="!isError" class="d-flex align-center column-gap-2">
      <app-material-icon name="folder" color="#2196F3"></app-material-icon>
      <span class="text--x-small text--bold">{{ uploadHint.destinationFolder }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { DRAG_AND_DROP_MESSAGE_TYPE } from '../utils/dragAndDropMessageType'

export default {
  name: 'AppFileUploadHint',
  data () {
    return {
      DRAG_AND_DROP_MESSAGE_TYPE,
    }
  },
  computed: {
    ...mapState('appUploadHandler', ['uploadHint']),
    ...mapState('documents', ['documentsToMove']),
    isError () {
      return this.uploadHint.messageType === DRAG_AND_DROP_MESSAGE_TYPE.ERROR_NOT_ALLOWED_FOLDER || this.uploadHint.messageType === DRAG_AND_DROP_MESSAGE_TYPE.ERROR_DROP_IN_SELECTED_FOLDER
    },
  },
}
</script>

<style scoped lang="scss">
.AppFileUploadHint {
  z-index: 5;
  position: fixed;
  bottom: 42px;
  left:50%;
  transform: translateX(-50%);
  width: 388px;
  padding: 42px 32px 16px 32px;
  background-color: white;

  & > * {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 6px 0;
  }
}

.header-icon {
  position: absolute;
  top: -42px;
  left: 158px;

  &__stack {
    position: relative;

    & > * {
      position: absolute;
    }
  }
}
</style>
